import { Outlet } from 'react-router-dom'

export function AppIndex() {
  return (
    <>
      <Outlet />
    </>
  )
}
